import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ReservationEndContext } from 'src/contexts/ReservationEndContext';
import { PaymentProvider } from 'src/entities/pocket';

const messages = defineMessages({
    barionStatement: {
        id: 'barionStatement',
        defaultMessage: 'Az online fizetést a Barion Payment Zrt. biztosítja, MNB engedély száma: H-EN-I-1064/2013.'
    }
})

const BarionStatement: React.FC = () => {

    const { selectedPayment } = useContext(ReservationEndContext);

    return (
        (selectedPayment?.PaymentProvider === PaymentProvider.Barion)
            ?
            <div className='reservation-end__statement'>
                <FormattedMessage {...messages.barionStatement} />
            </div>
            :
            null
    );
}

export default BarionStatement;